type ScrollLogicalPosition = 'start' | 'center' | 'end' | 'nearest'

export const scrollToElement = (elem: Element, scrollPosition: ScrollLogicalPosition) => {
  if (elem) {
    elem.scrollIntoView({ block: scrollPosition, behavior: 'smooth' })
  }
}

export const scrollToElementWithDelay = (elem: Element, time: number, scrollPosition: ScrollLogicalPosition) => {
  if (elem) {
    setTimeout(scrollToElement, time, elem, scrollPosition)
  }
}

export const scrollToTopToast = (toastClassName: string, delay: number, scrollPosition: ScrollLogicalPosition) => {
  const toasts = document.getElementsByClassName(toastClassName)

  const firstToast = toasts.item(0)
  if (firstToast) {
    if (delay > 0) {
      scrollToElementWithDelay(firstToast, delay, scrollPosition)
    } else {
      scrollToElement(firstToast, scrollPosition)
    }
  }
}
